/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Focus on search input on offcanvas open
document.querySelector('#offcanvas-search').addEventListener('shown.bs.offcanvas', () => {
    document.querySelector('#offcanvas-search input[name="q"]').focus();
});

// Handle Predictive Search
document.querySelectorAll('.predictive-search-input').forEach((input) => {
    input.addEventListener('input', window.debounce((e) => {
        const form = e.target.closest('form');
        const { value } = e.target;
        const results = form.querySelector('.predictive-search-results');
        const clearBtn = form.querySelector('.btn-clear');

        if (value.length === 0) {
            results.classList.remove('show');
            clearBtn.classList.remove('show');
            input.setAttribute('aria-expanded', 'false');
        } else {
            const {
                textOldPrice,
                textPriceFrom,
                textViewAllResults,
                textTitleCollections,
                textTitleProducts,
                textTitleArticles,
            } = results.dataset;

            const url = `/search/suggest.json?q=${value}&resources[type]=product,collection,article&resources[limit]=10&resources[options][unavailable_products]=last`;

            fetch(url)
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                    const { collections, products, articles } = data.resources.results;

                    if (products.length || collections.length || articles.length) {
                        let collectionListItems = '';
                        let productListItems = '';
                        let articleListItems = '';

                        collections.forEach((collection) => {
                            collectionListItems += `
                                <li class="p-1">
                                    <a 
                                        href="${collection.url}" 
                                        class="btn btn-outline-dark btn-sm py-1 lh-sm text-ellipsis">
                                        ${collection.title}
                                    </a>
                                </li>
                            `;
                        });

                        products.forEach((product) => {
                            productListItems += `
                                <li class="product-list-item py-2">
                                    <a href="${product.url}" class="text-decoration-none text-dark d-block">
                                        <div class="d-flex align-items-center bg-white py-0">
                                            <img 
                                                class="product-img img-fluid me-4"
                                                src="${window.resizeImage(product.featured_image.url || 'no-image.gif', '110x110', 'center')}"
                                                alt="${product.featured_image.alt}" 
                                                width="110"
                                                height="110"
                                                loading="lazy">
                                            <div>
                                                <h5 class="product-title h6 small mb-2">
                                                    ${product.title}
                                                </h5>
                                                <p class="product-price mb-1">
                                                    <s class="product-price-compare text-secondary me-1 ${product.compare_at_price_min > product.price ? '' : 'd-none'}">
                                                        <span class="visually-hidden">
                                                            ${textOldPrice}
                                                        </span>
                                                        ${window.formatMoney(product.compare_at_price_min)}
                                                    </s>
                                                    <span class="product-price-final">
                                                        <span class="product-price-from ${product.price_min !== product.price_max ? '' : 'd-none'}">
                                                            ${textPriceFrom}
                                                        </span>
                                                        ${window.formatMoney(product.price)}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            `;
                        });

                        articles.forEach((article) => {
                            articleListItems += `
                            <li class="article-list-item py-2">
                            <a href="${article.url}" class="text-decoration-none text-dark d-block">
                                <div class="d-flex align-items-center bg-white py-0">
                                    <img 
                                        class="product-img img-fluid me-4"
                                        src="${window.resizeImage(article.featured_image.url || 'no-image.gif', '110x110', 'center')}"
                                        alt="${article.featured_image.alt}" 
                                        width="110"
                                        height="110"
                                        loading="lazy">
                                    <div>
                                        <h5 class="product-title h6 small mb-2">
                                            ${article.title}
                                        </h5>
                                    </div>
                                </div>
                            </a>
                        </li>
                            `;
                        });

                        results.innerHTML = `
                            <div class="predictive-search-product-list ${products.length ? '' : 'd-none'}">
                                <h4 class="title h6 section-title small text-uppercase mt-0 mb-3 ls-2 text-center">
                                    <span class="px-3">${textTitleProducts}</span>
                                </h4>
                                <ul class="product-list list-unstyled mt-2 mb-4">
                                    ${productListItems}
                                </ul>
                            </div>
                            <div class="predictive-search-collection-list ${collections.length ? '' : 'd-none'}">
                                <h4 class="title h6 section-title small text-uppercase mt-3 mb-3 ls-2 text-center">
                                    <span class="px-3">${textTitleCollections}</span>
                                </h4>
                                <ul class="collection-list list-unstyled d-flex flex-wrap mx-0 mt-2 mb-7 mx-n1">
                                    ${collectionListItems}
                                </ul>
                            </div>
                            <div class="predictive-search-articles-list ${articles.length ? '' : 'd-none'}">
                                <h4 class="title h6 section-title small text-uppercase mt-3 mb-3 ls-2 text-center">
                                    <span class="px-3">${textTitleArticles}</span>
                                </h4>
                                <ul class="collection-list list-unstyled d-flex flex-wrap mx-0 mt-2 mb-7 mx-n1">
                                    ${articleListItems}
                                </ul>
                            </div>
                            <hr class="mt-0">
                            <div class="pb-2">
                                <button type="submit" class="btn btn-sm w-100 btn-primary">
                                    ${textViewAllResults}
                                </button>
                            </div>
                        `;

                        results.classList.add('show');
                        clearBtn.classList.add('show');
                        input.setAttribute('aria-expanded', 'true');
                    } else {
                        results.classList.remove('show');
                        input.setAttribute('aria-expanded', 'false');
                    }
                });
        }
    }));
});

// Handle Clear button
document.querySelectorAll('.predictive-search-input-wrapper .btn-clear').forEach((btn) => {
    btn.addEventListener('click', () => {
        btn.classList.remove('show');
        btn.closest('form').querySelector('input[name="q"]').value = '';
        btn.closest('form').querySelector('.predictive-search-results').classList.remove('show');
    });
});
